import { heroStats, heroTags } from "@/mocks/gallery";

export default function Hero() {
  return (
    <section id="top" className="relative pt-24 md:pt-28 pb-16 md:pb-24 bg-background-50 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-primary-100/60 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[320px] h-[320px] rounded-full bg-accent-100/60 blur-3xl pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="reveal-in">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
              <i className="ri-bookmark-line"></i>
              图片资源整理 · 一站式浏览入口
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-tight text-foreground-950">
              年轻的岳母图片浏览站
              <span className="block mt-2 text-primary-600">写真 · 壁纸 · 自拍，一次看全</span>
            </h1>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700 max-w-xl">
              这里把与「年轻的岳母」相关的图片资源集中整理：高清写真、日常自拍、室内人像、户外旅拍，以及适配手机与电脑的壁纸资源，按不同主题分区呈现。无需来回切换搜索结果，从导航栏进入对应分区，就能直接找到想看的那一类。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200/80 text-xs text-foreground-700"
                >
                  {tag}
                </span>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#featured"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-grid-line"></i>
                浏览精选合集
              </a>
              <a
                href="#categories"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-secondary-300 text-secondary-900 text-sm font-medium hover:bg-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-filter-3-line"></i>
                按主题查找
              </a>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
              {heroStats.map((stat) => (
                <div key={stat.label} className="rounded-lg bg-background-100/80 border border-background-200/70 p-3 md:p-4">
                  <div className="font-heading text-xl md:text-2xl font-semibold text-primary-600">{stat.value}</div>
                  <div className="mt-1 text-xs text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative h-[360px] md:h-[520px]">
            <div className="absolute top-0 right-0 w-[72%] h-[80%] rounded-lg overflow-hidden border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20an%20elegant%20asian%20woman%20by%20a%20large%20bright%20window%2C%20warm%20cream%20and%20terracotta%20tones%2C%20soft%20natural%20light%2C%20refined%20minimal%20interior%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=1000&seq=ylwm-hero-main&orientation=portrait"
                alt="窗边暖光下的优雅人像写真，米色与暖棕色调"
                className="w-full h-full object-top animate-slow-zoom"
              />
            </div>
            <div className="absolute bottom-0 left-0 w-[52%] h-[52%] rounded-lg overflow-hidden border-4 border-background-50 animate-floaty">
              <img
                src="https://readdy.ai/api/search-image?query=cozy%20lifestyle%20self%20portrait%20of%20a%20woman%20at%20home%20with%20a%20cup%20of%20tea%2C%20soft%20warm%20light%2C%20cream%20and%20beige%20interior%2C%20editorial%20photography%2C%20high%20detail&width=600&height=600&seq=ylwm-hero-sub&orientation=squarish"
                alt="居家暖光下的日常自拍记录"
                className="w-full h-full object-top"
              />
            </div>
            <div className="absolute top-[8%] left-[2%] rounded-lg bg-background-50 border border-background-200/70 px-3 py-2">
              <div className="flex items-center gap-2">
                <span className="w-7 h-7 rounded-md bg-accent-500 flex items-center justify-center text-foreground-950">
                  <i className="ri-image-line text-sm"></i>
                </span>
                <div className="leading-tight">
                  <div className="text-xs font-medium text-foreground-950">120+ 合集</div>
                  <div className="text-[10px] text-foreground-500">持续整理中</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}